// Backend API endpoints.  Match the route surface in backend/Server.js exactly.
//
// In production the build picks BASE up from REACT_APP_API_BASE — set it
// in `.env.production` (or a CI env var) to the public VPS URL, e.g.
// REACT_APP_API_BASE=https://bisongdb.yourcareconnect.online/
// In dev we fall back to localhost:5001 so `npm start` keeps working.
//const RAW_BASE = (process.env.REACT_APP_API_BASE || "http://localhost:5001/").trim();
const RAW_BASE = (process.env.REACT_APP_API_BASE || "https://bisongdb.yourcareconnect.online/").trim();
// Always end with a single trailing slash so `BASE + 'login'` is correct.
export const BASE = RAW_BASE.endsWith("/") ? RAW_BASE : `${RAW_BASE}/`;

// Static asset host — same origin as BASE but without the trailing slash
// so we can write `${ASSETS}/uploads/…` consistently.
export const ASSETS = BASE.replace(/\/+$/, "");


// First-run setup
export const facilityStatus = BASE + 'facilityStatus';
export const facility       = BASE + 'facility';
export const uploadLogo     = BASE + 'uploadLogo';
export const setupFacility  = BASE + 'setupFacility';

// Auth
export const login          = BASE + 'login';
export const changePassword = BASE + 'changepassword';

// User management (super_admin only)
export const newUser          = BASE + 'newUser';
export const loadsysUsers     = BASE + 'loadUsers';
export const deleteUserUrl    = BASE + 'deleteUser';
export const updateUserStatus = BASE + 'updateUserStatus';

// Roles & permissions
export const rolesUrl       = BASE + 'roles';
export const roleByIdUrl    = (id) => `${BASE}roles/${id}`;
export const permissionsUrl = BASE + 'permissions';

// Dashboard / activity feed
export const overviewUrl = BASE + 'overview';
export const activityUrl = BASE + 'activity';

// Rooms & room types
export const roomTypesUrl       = BASE + 'roomTypes';
export const roomTypeByIdUrl    = (id) => `${BASE}roomTypes/${id}`;
export const roomsUrl           = BASE + 'rooms';
export const roomsBulkUrl       = BASE + 'rooms/bulk';
export const roomByIdUrl        = (id) => `${BASE}rooms/${id}`;
export const roomStatusUrl      = (id) => `${BASE}rooms/${id}/status`;
export const uploadRoomImageUrl = BASE + 'uploadRoomImage';

// Guests
export const guestsUrl       = BASE + 'guests';
export const guestByIdUrl    = (id) => `${BASE}guests/${id}`;

// Reservations (covers bookings, check-in, check-out, cancel, payments)
export const reservationsUrl        = BASE + 'reservations';
export const reservationByIdUrl     = (id) => `${BASE}reservations/${id}`;
export const reservationCheckInUrl  = (id) => `${BASE}reservations/${id}/checkin`;
export const reservationCheckOutUrl = (id) => `${BASE}reservations/${id}/checkout`;
export const reservationCancelUrl   = (id) => `${BASE}reservations/${id}/cancel`;
export const reservationPaymentsUrl = (id) => `${BASE}reservations/${id}/payments`;
// Cross-reservation payment ledger — drives the Billing report's revenue table.
export const paymentsUrl            = BASE + 'payments';
export const reservationConfirmUrl  = (id) => `${BASE}reservations/${id}/confirm`;

// ── Public / visitor website ──────────────────────────────────────────────
// /public/* is open to anyone; /guest/* requires a guest session header.
export const publicRoomsUrl       = BASE + 'public/rooms';

export const guestSignupUrl       = BASE + 'guest/signup';
export const guestLoginUrl        = BASE + 'guest/login';
export const guestMeUrl           = BASE + 'guest/me';
export const guestReservationsUrl = BASE + 'guest/reservations';
export const guestCancelReservationUrl = (id) => `${BASE}guest/reservations/${id}/cancel`;

// System settings (key/value store powering the Settings page).
export const settingsUrl = BASE + 'settings';

// SMS gateway — operator-facing Messages page + auto-trigger history.
export const smsListUrl       = BASE + 'sms';
export const smsSendUrl       = BASE + 'sms/send';
export const smsTemplatesUrl  = BASE + 'sms/templates';
export const smsPreviewUrl    = BASE + 'sms/preview';
export const smsRecipientsUrl = BASE + 'sms/recipients';
export const smsBalanceUrl    = BASE + 'sms/balance';

// Legacy aliases kept so existing imports don't break while we migrate the UI.
export const createUser = newUser;
export const me         = ''; // no /me endpoint — user is cached in localStorage
export const deleteUser = (id) => `${BASE}deleteUser`; // POST with { id } in body
